module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADnSURBVHgBjVK7EcIwDLXTkwWSBQwDJAswQSZgAdLRUTEBS4QGFoDOXbpU0FGROcwT93L4jM1Fd8+y9bP0bK0i4pwroQyPo9b6HsZoBjZQV2AFtEzqGTMVOKDALbzhBHSABapIBw1921jiE2iBBW0bgRdT+IUz2s/ABZDZctpyb6/Q5gi14yhp4e1txD4IeZkswFrNFyHNSKvCWhMJEAaFFKMSLcmNQ8K3JCHGs33PZLX6k9xx/3kW31mzUqkSws7sDx9k0fIXhb46/AA6CJBqex4f1DKC/NUj3rKPJvpzQRVTASS8wpg3e3HCKwgMRnYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yi.png
// module id = VIfc
// module chunks = 1